import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store, Action } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {  map } from 'rxjs/operators';
import * as fromActions from '../actions/session.actions';

@Injectable()
export class SessionEffects {

    constructor(
        private actions$: Actions,
        private store: Store<any>
    ) { }

    @Effect()
    init$: Observable<Action> = this.actions$.pipe(
        ofType(fromActions.SESSION_ACTION_TYPES.INIT),
        map(() => {
            const id = this.uuid();
            return new fromActions.Action_Session_Started({ id });
        })
    );

    private uuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            // tslint:disable: no-bitwise
            // tslint:disable-next-line: one-variable-per-declaration
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
